var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThankyouSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "thankyouSuccess_svg__a",
    x1: "-52.882%",
    x2: "78.497%",
    y1: "77.391%",
    y2: "44.667%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#376DA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#245791"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "thankyouSuccess_svg__b",
    x1: "-52.882%",
    x2: "78.497%",
    y1: "194.817%",
    y2: "21.805%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#376DA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#245791"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2B8CAB",
    d: "M232.58 5.35h14.72c18.168 0-12.249-5.184 0-5.184h66.485c62.024 0 82.89.471 55.874 5.183-27.017 4.712-23.802 1.414 24.751 0 48.554-1.413 25.843 9.732-28.968 9.732-54.81 0-207.465 3.777-178.722 0 19.162-2.518 48.054-4.724 86.677-6.618L232.58 5.349z",
    opacity: 0.276
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#thankyouSuccess_svg__a)",
    d: "M.108 201.279c4.053-33.333 24.54-50 61.457-50 55.377 0 59.925-47.25 97.161-65.872 37.237-18.623 51.079 12.29 91.596-15.518 40.518-27.808 70.38-51.625 113.958-29.877 29.052 14.498 33.862 68.254 14.43 161.267H.108z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#F8FCFE",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.555 45.689v4.734M128.988 49.26l-3.68 2.98M130.836 57.334l-4.613-1.065M125.697 63.783l-2.076-4.254M117.413 63.783l2.076-4.254M112.274 57.334l4.613-1.065M114.121 49.26l3.68 2.98"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(121.566 74.859)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0F493F",
    d: "M.561 57.6h117.12v63.36a3.2 3.2 0 01-3.2 3.2H3.761a3.2 3.2 0 01-3.2-3.2V57.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.16,
    height: 93.44,
    x: 12.8,
    y: 0.402,
    fill: "#F8FCFE",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AABAE3",
    d: "M25.88 47.141h66v4h-66zm10 10.083h46v4h-46zm5 10h36v4h-36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D7CD3",
    d: "M117.681 57.6v63.36a3.2 3.2 0 01-3.2 3.2H3.928a.64.64 0 01-.318-1.195L117.681 57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D7CD3",
    d: "M.561 57.6v63.36a3.2 3.2 0 003.2 3.2h110.553a.64.64 0 00.318-1.195L.562 57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008CFF",
    d: "M59.12 91.156l55.512 31.809a.64.64 0 01-.318 1.195H3.928a.64.64 0 01-.318-1.195l55.51-31.81z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 180.566,
    cy: 99.127,
    r: 13.6,
    fill: "url(#thankyouSuccess_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M175.366 99.647l3.12 3.12 7.28-7.28"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 94.967,
    r: 4,
    fill: "#F8FCFE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.401,
    cy: 92.967,
    r: 2,
    fill: "#F8FCFE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.366,
    cy: 50.859,
    r: 2.6,
    fill: "#F8FCFE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.868,
    cy: 38.659,
    r: 6.2,
    stroke: "#F8FCFE",
    strokeWidth: 3
  }))));
}
export default SvgThankyouSuccess;